import { Action, createReducer, on } from '@ngrx/store';
import { LocationActivePasses } from '../../models/LocationActivePasses';
import {
	loadLocationActivePasses,
	loadLocationActivePassesFailure,
	loadLocationActivePassesSuccess,
	receiveLiveLocationActivePasses,
} from './location-active-passes.actions';

export interface LocationActivePassesState {
	locationMap: Map<number, LocationActivePasses>;
	loading: boolean;
	error: unknown;
}

export const initialState: LocationActivePassesState = {
	locationMap: new Map(),
	loading: false,
	error: null,
};

const reducer = createReducer<LocationActivePassesState, Action>(
	initialState,
	on(loadLocationActivePasses, (state) => ({
		...state,
		loading: true,
		error: null,
	})),
	on(loadLocationActivePassesSuccess, (state, { data }) => ({
		...state,
		locationMap: new Map(data.map((location) => [location.location_id, location])),
		loading: false,
	})),
	on(loadLocationActivePassesFailure, (state, { error }) => ({
		...state,
		loading: false,
		error,
	})),
	on(receiveLiveLocationActivePasses, (state, { data }) => ({
		...state,
		locationMap: new Map(state.locationMap).set(data.location_id, data),
	}))
);

export function locationActivePassesReducer(state: LocationActivePassesState | undefined, action: Action): LocationActivePassesState {
	return reducer(state, action);
}
